import { useMutation } from '@tanstack/react-query';

/**
 * Mutation hook for editing bulk upload rows.
 *
 * @param {Object} options
 * @param {Object} options.api - API object with edit function
 * @param {Object} options.params - Additional params to pass to the API
 * @param {string|null} options.uploadKey - The bulk upload key
 * @param {Function} [options.onSuccess] - Callback when edit succeeds
 * @returns {import('@tanstack/react-query').UseMutationResult}
 */
function useEditRows({ api, onSuccess, params, uploadKey }) {
    return useMutation({
        mutationFn: async ({ rowsToDelete, rowsToUpdate }) => {
            const response = await api.edit(uploadKey, params, rowsToUpdate, rowsToDelete);
            if (!response?.status) {
                throw new Error(response?.msg ?? 'Edit failed');
            }
            return response.data;
        },
        onMutate: () => ({ params, uploadKey }),
        onSuccess,
    });
}

export { useEditRows };
